// StudentResources.jsx
import React, { useEffect, useState } from "react";
import axiosInstance from "../../api/axios";
import {Sidebar} from "../sidebar/Sidebar";
import {Navbar} from "../navbar/Navbar";
import "../../pages/new/new.scss"
import "../datatable/datatable.scss"
//import React, { useState, useEffect } from 'react';
import {Link, useParams, useNavigate, useLocation } from 'react-router-dom';

//import { getAllThesis, getFeedbackById } from '../../services/thesisService';
import {getStudentSelfEvaluation} from '../../services/selfEvaluationService';
import { toast } from 'react-toastify';
import TextBox from './TextBox';
import { DataGrid } from '@mui/x-data-grid';


import "../featured/featured.scss"

import { getCurrentTerm} from '../../services/termService';
export const StudentResources = () => {
  const username = localStorage.getItem('username') || '';
  const isAllowed = username.toLowerCase().startsWith('ch24');
  const isAllowed23 = username.toLowerCase().startsWith('ch23') || username.toLowerCase().startsWith('ch22');
//  console.log('username:', username);
//console.log('isAllowed:', isAllowed);
//console.log('isAllowed23:', isAllowed23);
    const pdfFiles = [
      { name: 'Session 1', url: '/pdfs/session1.pdf' },
  //    { name: 'Session 2', url: '/pdfs/brochure.pdf' },
  //    { name: 'Session 3', url: '/pdfs/brochure.pdf' },
    ];

    const recordingFiles = [
    { name: 'Session 1', url: 'https://drive.google.com/file/d/1sTisNtlYJRIs1u6vgi3bln91GZLnFELx/view?usp=sharing' },
  //  { name: 'Session 2', url: '/pdfs/brochure.pdf' },
  //  { name: 'Session 3', url: '/pdfs/brochure.pdf' },
  ];

  
    const handlePDFSelect = (event) => {
      const selectedPdf = event.target.value;
      if (selectedPdf) {
        window.open(selectedPdf, '_blank'); // Opens the PDF in a new tab
      }
    }
  
    return (
      <div className="featured">
        <div>
        {isAllowed && (<ul className="pdf-list" >
        <li>
            <a href="/pdfs/session1.pdf" target="_blank" rel="noopener noreferrer">
              Session 1 Presentation
            </a>
          </li> 
          <li>
            <a href='https://drive.google.com/file/d/1sTisNtlYJRIs1u6vgi3bln91GZLnFELx/view?usp=sharing' target="_blank" rel="noopener noreferrer">
              Session 1 Recording
            </a>
          </li>

          
          <li>
            <a href='https://drive.google.com/file/d/1To1whunn0-Mj2KohInd3kyT7YbpaKVot/view?usp=sharing' target="_blank" rel="noopener noreferrer">
              Session 2 Presentation : Literature Search
            </a>
          </li>
          

          <li>
            <a href='https://drive.google.com/file/d/1fkD-AIupVK3wpmtN_LkjkkYev8TIujN0/view?usp=sharing' target="_blank" rel="noopener noreferrer">
              Session 2 Recording
            </a>
          </li>
          
          <li>
            <a href='https://drive.google.com/file/d/1U30BN3c7sHf6qR1enYB0t_ZXDaMd-egi/view?usp=sharing' target="_blank" rel="noopener noreferrer">
              Project Proposal Template
            </a>
          </li>


          <li>
            <a href='https://drive.google.com/file/d/1uH4RnqHqWAa7FKdCnGUFIoCezMqNF9B_/view?usp=sharing' target="_blank" rel="noopener noreferrer">
              Session 3 Recording : Project Proposal Writing
            </a>
          </li>

          <li>
            <a href='https://drive.google.com/file/d/14jSlf8DHzaGPJGD118POciv8TQ2EpKsa/view?usp=sharing' target="_blank" rel="noopener noreferrer">
              End Report Template
            </a>
          </li>

          <li>
            <a href='https://drive.google.com/file/d/11apmC5waR9LhiIlXa3I5_sgWqkUQaLQW/view?usp=sharing' target="_blank" rel="noopener noreferrer">
              Rebuttal Report Template
            </a>
          </li> 

          
          

          </ul>
        )}
          {isAllowed23 && (<ul className="pdf-list" >
        <li>
            <a href="https://drive.google.com/file/d/1UiG5yCXt0QWcKzWHppeW5og41BO_IVvy/view?usp=sharing" target="_blank" rel="noopener noreferrer">
              Presentation
            </a>
          </li> 
          <li>
            <a href='https://drive.google.com/file/d/17FbaVF9QjbbOFfe4z7LzigpKuxv3J7n9/view?usp=sharing' target="_blank" rel="noopener noreferrer">
              Session Recording
            </a>
          </li> 
          <li>
            <a href='https://drive.google.com/file/d/11apmC5waR9LhiIlXa3I5_sgWqkUQaLQW/view?usp=sharing' target="_blank" rel="noopener noreferrer">
              Rebuttal Report Template
            </a>
          </li> 

          

         
         {/*  <li>
            <div className="pdf-dropdown">
              <label htmlFor="pdfSelector">Session Presentations </label>
              <select id="pdfSelector" onChange={handlePDFSelect}>
                <option value="">Select a Session</option>
                {pdfFiles.map((pdf, index) => (
                  <option key={index} value={pdf.url}>
                    {pdf.name}
                  </option>
                ))}
              </select>
            </div>
          </li>
          <li>
            <div className="pdf-dropdown">
              <label htmlFor="pdfSelector">Session Recordings </label>
              <select id="pdfSelector" onChange={handlePDFSelect}>
                <option value="">Select a Session</option>
                {recordingFiles.map((link, index) => (
                  <option key={index} value={link.url}>
                    {link.name}
                  </option>
                ))}
              </select>
            </div>
          </li>
          */}
        </ul>
        )}
      </div>

  
       
  
  
      </div> 
    )
};
